import React from 'react';
import cx from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import blue from '@material-ui/core/colors/blue';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { createStyles, makeStyles } from '@material-ui/core';
var variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    danger: ErrorIcon,
    info: InfoIcon,
};
var useStyles = makeStyles(function (theme) {
    return createStyles({
        success: {
            backgroundColor: theme.palette.ok.dark,
        },
        danger: {
            backgroundColor: theme.palette.error.dark,
        },
        info: {
            backgroundColor: blue[700],
        },
        warning: {
            backgroundColor: theme.palette.warning.dark,
        },
        alert: {
            marginBottom: theme.spacing(0.25),
            maxWidth: 'initial',
        },
        iconVariant: {
            opacity: 0.9,
            marginRight: theme.spacing(1),
        },
        message: {
            display: 'flex',
            alignItems: 'center',
        },
    });
});
export var Alert = function (props) {
    var action = props.action, className = props.className, message = props.message, variant = props.variant;
    var classes = useStyles();
    var alertVariant = variant || 'info';
    var Icon = variantIcon[alertVariant];
    return (React.createElement(SnackbarContent, { action: action, className: cx(classes.alert, classes[alertVariant], className), message: React.createElement("span", { className: classes.message },
            React.createElement(Icon, { className: classes.iconVariant }),
            message) }));
};
export default Alert;
//# sourceMappingURL=index.js.map